"use client";

import { BlogLink, Content, Header } from "@/components/shared/public/blogs";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section2,
} from "../../../../../../public/images/blogs/immoFloorPlan";

export default function BlogContent() {
  const t = useTranslations("blogs.immoFloorPlan");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t.rich("header.text", {
          link: (chunks) => (
            <Link
              className="font-bold hover:underline"
              href="/blog/immobilienmarketing"
            >
              {chunks}
            </Link>
          ),
          link1: (chunks) => (
            <Link className="font-bold hover:underline" href="/blog/grundriss">
              {chunks}
            </Link>
          ),
        })}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/grundriss">{chunks}</BlogLink>
            ),
            link1: (chunks) => (
              <BlogLink href="/blog/immobilienmarketing">{chunks}</BlogLink>
            ),
            link2: (chunks) => (
              <BlogLink href="/blog/schnitte-und-ansichten">{chunks}</BlogLink>
            ),
            link3: (chunks) => (
              <BlogLink href="/blog/hausgrundriss">{chunks}</BlogLink>
            ),
            link4: (chunks) => (
              <BlogLink href="/blog/wohnflaeche">{chunks}</BlogLink>
            ),
            link5: (chunks) => (
              <BlogLink href="/blog/information-virtueller-rundgang">
                {chunks}
              </BlogLink>
            ),
            link6: (chunks) => (
              <BlogLink href="/blog/virtueller-rundgang">{chunks}</BlogLink>
            ),
            link7: (chunks) => (
              <BlogLink href="/blog/expose">{chunks}</BlogLink>
            ),
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
            link: (chunks) => (
              <BlogLink href="/blog/immobilienmakler">{chunks}</BlogLink>
            ),
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
          disclaimer="default"
        />
      </div>
    </>
  );
}
